import { useSubscription } from "@foundation/contextapi/SubscriptionContext";

export type PolicyUsage = {
  current: number;
  limit: number;
  allowed: boolean;
  count: number;
};

export type UseSubscriptionUsageReturn = {
  subscriptionData: unknown;
  isLoading: boolean;
  error: string | null;
  refreshUsage: () => Promise<void>;
  canCreatePolicy: boolean;
  policyUsage: PolicyUsage | null;
  planName: string | null;
  tierLevel: number;
};

export const useSubscriptionUsage = (): UseSubscriptionUsageReturn => {
  const {
    subscriptionSummary,
    organizationSubscription,
    isLoading,
    loadSubscriptionSummary,
    availablePlans,
  } = useSubscription();

  const policyResource = subscriptionSummary?.resources?.find(
    (r: any) => r.code === 'revisr_final_policies'
  );

  const current: number = policyResource?.current_usage ?? 0;
  const limit: number = policyResource?.total_limit ?? -1;
  const allowed = limit === -1 ? true : current < limit;

  const policyUsage: PolicyUsage | null = policyResource
    ? { current, limit, allowed, count: current }
    : null;

  const canCreatePolicy = allowed;

  // Get plan name and tier from availablePlans
  const activePlan = availablePlans?.find(
    (p: any) => p.id === organizationSubscription?.plan_id
  );
  const planName: string | null = (activePlan as any)?.name ?? null;
  const tierLevel: number = (activePlan as any)?.tier_level ?? 0;

  const refreshUsage = async () => {
    if (organizationSubscription?.id) {
      await loadSubscriptionSummary(organizationSubscription.id);
    }
  };

  return {
    subscriptionData: subscriptionSummary,
    isLoading,
    error: null,
    refreshUsage,
    canCreatePolicy,
    policyUsage,
    planName,
    tierLevel,
  };
};
